import React, { useState, Fragment } from 'react';
import { Form, Row, Col } from "react-bootstrap";
import EngineSearch from './engine/EngineSearch';
import SimpleSearch from './simple/SimpleSearch';
import { useSessionStorage } from "./useSessionStorage";

const SearchHome = ({pCustId}) => {
    console.log("SearchHome");

    const [searchMode, setSearchMode] = useSessionStorage("searchMode", "model");

    const [custId, setCustId] = useState(pCustId);

    const handleSearchByModel = () => {
        setSearchMode("model");
    }

    const handleSearchSimple = () => {
        setSearchMode("simple");
    }

    return (
        <Fragment>
            <Form.Group as={Row} className="filter-dc">
                <Col>
                    <Form.Check
                        type="radio"
                        label="Model"
                        name="search_type"
                        id="model"
                        checked={searchMode == "model" ? "checked" : ""}
                        onChange={handleSearchByModel}
                        inline
                    />
                    <Form.Check
                        type="radio"
                        label="Search"
                        name="search_type"
                        id="simple"
                        checked={searchMode == "simple" ? "checked" : ""}
                        onChange={handleSearchSimple}
                        inline
                    />
                </Col>
            </Form.Group>

            {searchMode == "model" ? <EngineSearch pCustId={custId} /> : null}
            {searchMode == "simple" ? <SimpleSearch pCustId={custId} /> : null}
        </Fragment>
    )
}
export default SearchHome;